import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import UserService from '../../services/UserService'
import i18n from 'i18next'
import dayjs from 'dayjs'
import { environment } from '../../../enviroments/enviroment'

const baseQuery = fetchBaseQuery({
  baseUrl: environment.baseUrl,
  prepareHeaders: async (headers, { getState }) => {
    if (UserService.isTokenExpired()) {
      await UserService.updateToken(() => {})
    }

    const token = UserService.getToken()
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    const userTimezone = dayjs.tz.guess()
    const chosenLanguage = i18n.language
    headers.set('Accept-Language', chosenLanguage)
    headers.set('The-Timezone-IANA', userTimezone)

    return headers
  },
})

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQuery,
  tagTypes: [
    'User',
    'Project',
    'Technology',
    'WorkforceSchedule',
    'Worklog',
    'WorkActivity',
    'WorkActivityHistory',
    'Role',
    'Report',
    'YearlySummary',
    'Cost',
    'Demand',
    'Vacation',
    'Permission',
    'Candidate',
    'Recruitment',
    'Dictionary',
    'VacationAcknowledgement',
    'Comment',
    'PushNotification',
    'Contract',
  ],
  endpoints: builder => ({}),
})
